import { deserializeGameEventHistory } from './DeserializeGameEventHistory.ts';
import { validateGameEventHistory } from './GameEventHistory.ts';
import { migrateGameEventHistory } from './migrations/GameEventHistoryMigrationManager.ts';
export function hydrateGameEventHistory(gameEventHistory) {
    const deserializedGameEventHistory = deserializeGameEventHistory(gameEventHistory);
    const migratedGameEventHistory = migrateGameEventHistory(deserializedGameEventHistory);
    return validateGameEventHistory(migratedGameEventHistory);
}
